module.exports = __webpack_public_path__ + "static/media/defaultCover.fefc06ff.jpg";